import CertificatesCubos from '../assets/Certificates/certificatesCubos.png';
import CertificatesDevelopment from '../assets/Certificates/certificatesDevelopment.png';
import CertificatesDevForTech from '../assets/Certificates/certificatesDevForTech.jpg'

export const arrayCertificates = [
    {
        image: CertificatesCubos
    },
    {
        image: CertificatesDevForTech
    },
    {
        image: CertificatesDevelopment
    }
];